import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import BadgeAlarmIcon from '../../Icons/BadgeAlarmIcon';
import BadgeWarningIcon from '../../Icons/BadgeWarningIcon';
import BadgeSuccessIcon from '../../Icons/BadgeSuccessIcon';
import BadgeInfoIcon from '../../Icons/BadgeInfoIcon';

/**
Veicola un messaggio di potenziale interesse per l'utente.

_Quando si utilizza?_

Un panel contiene un messaggio che non è per forza scatenato da azioni dell'utente, ma anche dal sistema.

I messaggi possono essere raggruppati in 4 tipologie:

- _Informazione_: per comunicare un'informazione non correlata all'attuale attività dell'utente, ma che è potenzialmente utile.
- _Successo_: per informare che qualcosa è avvenuto correttamente.
- _Attenzione_: per avvertire l'utente di una condizione che potrebbe causare problemi in futuro.
- _Allarme/Errore_: per avvertire l'utente di un problema/errore presente.

Sia per la dimensione ridotta, che per una questione di facilità di lettura e comprensione,
i messaggi devono essere sintetici. Può esserti utile consultare la sezione dedicata ai Testi.
Per evitare di scrivere troppo si può anche inserire un link a maggiori dettagli.

Per i messaggi critici è più consigliato usare il panel piuttosto che una modale di Badge,
perché le persone tenderebbero a chiuderla senza neanche leggerla.
Basta disporre il panel nel contesto più adatto e specificare chiaramente cosa deve fare l'utente per poter risolvere il problema e
proseguire con il suo lavoro.

*/
const MiniPanel = ({
  className, type, position, message,
}) => (
  <div className={cns('v2-mini-panel', className, `v2-mini-panel--${type}`, `v2-mini-panel--${position}`)}>
    {type === 'info' && <BadgeInfoIcon />}
    {type === 'success' && <BadgeSuccessIcon />}
    {type === 'warning' && <BadgeWarningIcon />}
    {type === 'alarm' && <BadgeAlarmIcon />}
    <Arrow />
    <p className="v2-mini-panel__message">{message}</p>
  </div>
);

MiniPanel.propTypes = {
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Messaggio da visualizzare */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** Indica la tipologia del tooltip */
  type: PropTypes.oneOf(['info', 'alarm', 'warning', 'success']),
  /** Indica la posizione del messaggio rispetto all'icona */
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
};

MiniPanel.defaultProps = {
  className: undefined,
  type: 'info',
  position: 'right',
};

const Arrow = () => (
  <svg className="v2-mini-panel__arrow" viewBox="0 0 7.38 7.38">
    <path
      d="M9.89,11.45a.51.51,0,0,1-.22-.67.54.54,0,0,1,.22-.23l6.39-3.19a.5.5,0,0,1,.72.45v6.38a.5.5,0,0,1-.5.5.54.54,0,0,1-.22,0Z"
      transform="translate(-9.62 -7.31)"
    />
  </svg>

);

export default MiniPanel;
